'use strict';
exports.Client = require('./lib/client');

exports.STAGE_RELEASE = 'RELEASE';
exports.STAGE_PRE = 'PRE';
exports.STAGE_TEST = 'TEST';